import { Square } from 'lucide-react';
import type { CustomNodeProps } from '../../types/nodes';
import { BaseNode } from './BaseNode';

export function EndNode(props: CustomNodeProps) {
  return (
    <BaseNode
      {...props}
      icon={Square}
      canHaveOutputs={false}
    />
  );
} 